
isMobile = function () {
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    return isMobile.matches ? true : false
}

// desktop - so replace placeholder div with embed
$(".banner-video-enable-mobile-switch").each(function () {

    // get image
    var dataVideoPlaceholderImage = $(this).attr("data-videoplaceholderimage");
    var dataVideoPlaceholderImageDesktop = $(this).attr("data-videoplaceholderimagedesktop");
    var dataVideoProvider = $(this).attr("data-videoprovider");
    var dataActivateVideoOnMobile = $(this).attr("data-activatevideoonmobile");

    if (isMobile() && dataActivateVideoOnMobile == "False")
    {
         // change class
        $(this).addClass("banner-video-mobile-mode");

        // set mobile image
        $(this).css("background-image", "url('" + dataVideoPlaceholderImage + "')");
   
    } 
    else
    {
        var dataVideoUrl = $(this).attr("data-videourl");
        var dataVideoCode = $(this).attr("data-videocode");

        if (dataVideoProvider == "Youtube")
        {
            // ---------------Youtube ------------------

            var youtubeEmbedUrl = "https://www.youtube.com/embed/" + dataVideoCode + "?controls=0&showinfo=0&rel=0&autoplay=1&mute=0&loop=1&cc_load_policy=0&playlist=7BffwUQRBGI&enablejsapi=1&origin=https%3A%2F%2Fwww.giant-bicycles.com&widgetid=1";
            var videoHtml = '';
            videoHtml += '<div class="video-wrapper-outer">';
            videoHtml += '<div class="video-wrapper-inner">';
            videoHtml += '<div class="video-iframe-container" style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
            videoHtml += '<iframe width="560" height="315" src="' + youtubeEmbedUrl + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;height:100%;"></iframe>';
            videoHtml += '</div>';
            videoHtml += ' </div>';
            videoHtml += '</div>';

            $(this).prepend(videoHtml);

        }
        else if (dataVideoProvider == "Wistia")
        {
            // ------------------- Wistia -------------------
            if (GDPRactive) {
                window._wq = window._wq || [];
                window._wq.push(function (W) {
                    W.consent(false);
                    console.log("*GDPR-essential: Wistia consent is set to", W.consent()); // returns true or false
                });
            }

            // WISTIA 
            var wistiaEmbedUrl = "https://fast.wistia.net/embed/iframe/" + dataVideoCode + "?videoFoam=true";
            var videoHtml = '';
            videoHtml += '<div class="content-wrapper content-wrapper-wistia-embed video-cinema-format">';
            videoHtml += '<div class=wistia_responsive_padding>';
            videoHtml += '<div class=wistia_responsive_wrapper style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
            videoHtml += '<iframe src="' + wistiaEmbedUrl + '" allowtransparency=true frameborder=0 scrolling=no class=wistia_embed name=wistia_embed allowfullscreen mozallowfullscreen=true webkitallowfullscreen=true oallowfullscreen=true msallowfullscreen=true width=100% height=100%></iframe>';
            videoHtml += '</div>';
            videoHtml += '</div>';
            videoHtml += '</div>';

            $(this).prepend(videoHtml);
        }
        else
        {
           // --------------------- Hosted Video -----------------

           var videoHtml = '';
           videoHtml += '<div class="video-wrapper-outer">';
           videoHtml += '<div class="video-wrapper-inner">';
           videoHtml += '<div class="video-iframe-container" style="height:100%;left:0;position:absolute;top:0;width:100%;z-index:200">';
           videoHtml += '<video id="video" preload="auto" poster="' + dataVideoPlaceholderImageDesktop + '" loop="" autoplay="" muted="" volume="0.0" style="width:100%;height:100%;">';
           videoHtml += '<source src="'+ dataVideoUrl +'" type="video/mp4"/>';
           videoHtml += 'Video not supported ';
           videoHtml += '</video>';
           videoHtml += '</div>';
           videoHtml += '</div>';
           videoHtml += '</div>';

           $(this).prepend(videoHtml);
        }

    }

});